module.exports = "/_next/static/images/715d60bf6629a31c0add0dd8ef25f86b-iPhone12pro_3.png";